module.exports = __webpack_public_path__ + "img/dia_do_amigo.99f8e354.svg";